import React from "react";
import InputsContainer from "../InputsContainer/InputsContainer";

const FormBuilder = (props) => {
  return (
    <div className="flex flex-col gap-6 px-4 mb-8">
      <span className="font-bold text-[16px]">{props.data.name || ""}</span>
      {props.data.attributes.map((item) => (
        <InputsContainer data={item} />
      ))}
    </div>
  );
};

export default FormBuilder;
